import { render, staticRenderFns } from "./BrowseDaicho.vue?vue&type=template&id=60130f96&scoped=true&"
import script from "./BrowseDaicho.vue?vue&type=script&lang=js&"
export * from "./BrowseDaicho.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaicho.vue?vue&type=style&index=0&id=60130f96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60130f96",
  null
  
)

export default component.exports